import Vue from 'vue';
import Vuex from 'vuex';

import moment from 'moment';

Vue.use(Vuex);

const strict = process.env.NODE_ENV !== 'production';

const state = {
    channels: {},
    shopsGames: {},
    channels_live: {},
    channels_live_codes: {},
    streams: [],
    allowPurchase: {},
    allowPurchaseInfo: {},

    balance: undefined,

    datetime: undefined,

    tickets: {
        active: [],
        history: [],
    },

    pools: {},
    favorites: {},

    purchaseGameId: undefined,
    selection: undefined,
    selectionIsAdded: false,
    selectionsOfGames: {},

    connectionStatus: 'connecting',
    isLogged: Config.player_id ? true : false,
    displayNavigation: Config.display_navigation ? true : false,

    width: 0,

    message: {},

    allDraws: {},
};

const mutations = {
    updateChannel(state, channel) {
        Vue.set(state.allDraws, channel.draws.next._id, channel.draws.next);
        Vue.set(state.channels, channel.id, channel);
    },

    updateShopGame(state, shopGame) {
        Vue.set(state.shopsGames, shopGame.id, shopGame);
    },

    updateChannelLive(state, { channel_id, type }) {
        if (type == 'start') {
            Vue.set(state.channels_live, channel_id, true);
            let code = '-';
            
            if(state.channels[channel_id]) {
                const nextDraw = state.channels[channel_id].draws.next;
                
                if(state.channels[channel_id].draws.unfinished_list.length > 0 && nextDraw.remaining > 60) {
                    code = state.channels[channel_id].draws.unfinished_list[0].code
                } else {
                    code = state.channels[channel_id].draws.next.code;
                }
            }
            Vue.set(state.channels_live_codes, channel_id, code);
        } else if (type == 'end') {
            Vue.set(state.channels_live, channel_id, false);
        }
    },

    removeStream(state, channelId) {
        state.streams = state.streams.filter(stream => {
            return stream.channelId != channelId;
        });
    },

    addStream(state, stream) {
        state.streams.push(stream);
    },

    updateDatetime(state, datetime) {
        state.datetime = datetime;
    },

    updateAllowPurchase(state, { gameId, allow, info }) {
        Vue.set(state.allowPurchase, gameId, allow);
        Vue.set(state.allowPurchaseInfo, gameId, info);
    },

    updateBalance(state, balance) {
        state.balance = balance;
    },


    addTicket(state, { type, ticket, action }) {
        if(action === 'append') {
            state.tickets[type].push(ticket);
        } else {
            state.tickets[type].unshift(ticket);
        }
    },

    removeTicket(state, { type, id }) {
        state.tickets[type] = state.tickets[type].filter(ticket => ticket.id != id);
    },


    updatePoolAmount(state, { poolId, amount }) {
        Vue.set(state.pools, poolId, amount);
    },


    incrementDatetime(state) {
        const datetime = moment(state.datetime).add(1, 'seconds');

        state.datetime = datetime.format('YYYY-MM-DD HH:mm:ss');
    },


    setPurchaseGameId(state, gameId) {
        state.purchaseGameId = gameId;
    },

    setSelection(state, selection) {
        state.selection = selection;
    },

    setSelectionAdded(state, isAdded = true) {
        state.selectionIsAdded = isAdded;
    },

    setSelectionOfGame(state, { gameId, amountId, countId }) {
        Vue.set(state.selectionsOfGames, gameId, { amountId, countId } );
    },

    setConnectionStatus(state, status) {
        state.connectionStatus = status;
    },

    updateWidth(state, width) {
        state.width = width;
    },

    updateFavorites(state, { gameId, list }) {
        Vue.set(state.favorites, gameId, list);
    },

    logout(state) {
        state.isLogged = false;
    },

    setMessage(state, message) {
        state.message = message;
    },
};

const getters = {
    remaining: state => channelId => {
        const channel = state.channels[channelId];

        if (channel && channel.draws && channel.draws.next) {
            const from = moment(state.datetime)
            const to = moment(channel.draws.next.datetime);

            return to.diff(from, 'seconds');
        }
    },

    maxWinByGame: state => gameId => {
        const game = Config.games[gameId];

        if(!game) {
            return;
        }

        switch (game.name) {
            case 'Interjackpot':
            case 'Jokerjackpot':
                let largestPoolAmount = 0;

                for (const poolId of Object.keys(game.pools) ) {
                    const amount = state.pools[poolId];

                    if (amount > largestPoolAmount) {
                        largestPoolAmount = amount;
                    }
                }

                return largestPoolAmount;
            default:
                return game.max_win;
        }
    },

    activeTickets(state) {
        return state.tickets.active;
    },
    activeTicketsOfDraw: state => game => {
        const tickets = []; 
        const settingsIndex = Object.keys(Config.games).find(key => Config.games[key].id === game.id);
        const maxDuration = Config.games[settingsIndex].studio_max_duration;
        const channelDraws = state.channels[game.channel_id].draws;
        const allowTicketsBefore = Config.games[settingsIndex].allow_tickets_before;
        const now = moment(moment().utc().format("YYYY-MM-DD HH:mm:ss"));

        for (const ticket of state.tickets.active) {
            if (ticket.game != game.name) {
                continue;
            }

            let ticketDraw = undefined;

            if (ticket.draw_id == channelDraws.next._id) {
                ticketDraw = channelDraws.next;
            } else if(ticket.draw_id == channelDraws.finished._id) {
                ticketDraw = channelDraws.finished;
            } else if (state.allDraws[ticket.draw_id]) {
                ticketDraw = state.allDraws[ticket.draw_id];
            } else {
                ticketDraw = channelDraws.unfinished_list.find(element => element._id == ticket.draw_id)
            }

            if(ticketDraw) {
                const ticketMaxduration = moment(ticketDraw.datetime).add(maxDuration, 'seconds');
                const ticketDrawStart = moment(ticketDraw.datetime).add(-(allowTicketsBefore), 'seconds');
                
                if(now.isSameOrAfter(ticketDrawStart) && now.isBefore(ticketMaxduration)) {
                    tickets.push(ticket);
                }
            }
        }

        return tickets;
    },

    ticketsHistory(state) {
        return state.tickets.history;
    },

    isSmallWidth(state) {
        return state.width <= 768;
    },
};

const actions = {};

export default new Vuex.Store({ strict, state, mutations, getters, actions });